<script>
import { useAdmin } from 'dashboard/composables/useAdmin';
import BackButton from 'dashboard/components/widgets/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  props: {
    headerTitle: { default: '', type: String },
    buttonRoute: { default: '', type: String },
    buttonText: { default: '', type: String },
    icon: { default: '', type: String },
    showBackButton: { type: Boolean, default: false },
    showNewButton: { type: Boolean, default: false },
    backUrl: { type: [String, Object], default: '' },
  },
  setup(props, { emit }) {
    const { isAdmin } = useAdmin();
    return { isAdmin };
  },
  computed: {
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-between h-14 min-h-[3.5rem] px-6 py-2 bg-white dark:bg-slate-900 border-b border-slate-100 dark:border-slate-800/50 shadow-sm"
  >
    <div class="flex items-center">
      <BackButton
        v-if="showBackButton"
        :button-label="buttonText"
        :back-url="backUrl"
        class="ml-2 mr-4 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full p-2 transition-colors duration-200"
        @click.stop
      />
      <fluent-icon
        v-if="icon"
        :icon="icon"
        :class="iconClass"
        class="ml-1 mr-2 rtl:ml-2 rtl:mr-1 text-slate-600 dark:text-slate-300 md:block"
      />
    </div>

    <h1
      class="flex-1 text-center m-0 text-2xl font-semibold text-slate-600 dark:text-slate-300"
    >
      <span>
        {{ headerTitle }}
      </span>
    </h1>

    <div class="flex items-center gap-4">
      <router-link
        v-if="showNewButton && isAdmin"
        :to="buttonRoute"
        class="button success bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 shadow-sm transition-all duration-200 hover:shadow-md"
      >
        <fluent-icon icon="add-circle" class="text-lg" />
        <span class="button__content font-medium">
          {{ buttonText }}
        </span>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.button {
  transition: all 0.2s ease-in-out;
}

.button:hover {
  transform: translateY(-1px);
}

h1 {
  line-height: 1.2;
}
</style>
